import React, {useLayoutEffect} from "react";
import {ODUtil} from "../../../assets/js/components/util";
import ODLayoutHeader from "../../../assets/js/layout/base/header";
import ODLayoutHeaderMenu from "../../../assets/js/layout/base/header-menu";
import ODLayoutHeaderTopbar from "../../../assets/js/layout/base/header-topbar";
import ODLayoutBrand from "../../../assets/js/layout/base/brand";
import ODLayoutAside from "../../../assets/js/layout/base/aside";
import ODLayoutAsideToggle from "../../../assets/js/layout/base/aside-toggle";
import ODLayoutAsideMenu from "../../../assets/js/layout/base/aside-menu";
import ODLayoutContent from "../../../assets/js/layout/base/content";
import ODLayoutFooter from "../../../assets/js/layout/base/footer";
import ODLayoutScrolltop from "../../../assets/js/layout/extended/scrolltop";
import ODLayoutStickyCard from "../../../assets/js/layout/base/sticky-card";
import ODLayoutStretchedCard from "../../../assets/js/layout/base/stretched-card";
import ODLayoutQuickPanel from "../../../assets/js/layout/extended/quick-panel";
import ODLayoutQuickUser from "../../../assets/js/layout/extended/quick-user";
import SettingsPanel from "../../../assets/js/layout/extended/settings-panel";
import ODModulesDropdownToggle from "../../../assets/js/layout/base/modules-dropdown-toggle";
// import ODLayoutSubheader from "../../../assets/js/layout/base/subheader";

export function LayoutInit() {
  useLayoutEffect(() => {
    // Initialization
    ODUtil.ready(function () {
      ////////////////////////////////////////////////////
      // Layout Base Partials(mandatory for core layout)//
      ////////////////////////////////////////////////////
      // Init Desktop & Mobile Headers
      ODLayoutHeader.init('od_header', 'od_header_mobile');

      // Init Header Menu
      ODLayoutHeaderMenu.init('od_header_menu', 'od_header_menu_wrapper');
      // Init Header Topbar For Mobile Mode
      ODLayoutHeaderTopbar.init('od_header_mobile_topbar_toggle');
      // Init Brand Panel For Logo
      ODLayoutBrand.init('od_brand');
      // Init Aside
      ODLayoutAside.init('od_aside');
      // Init Aside Menu Toggle
      ODLayoutAsideToggle.init('od_aside_toggle');
      // Init Aside Menu
      ODLayoutAsideMenu.init('od_aside_menu');
      // Init Content
      ODLayoutContent.init('od_content');
      // Init Footer
      ODLayoutFooter.init('od_footer');

      //////////////////////////////////////////////
      // Layout Extended Partials(optional to use)//
      //////////////////////////////////////////////
      // ODLayoutSubheader.init('od_subheader');

      // Init Scrolltop
      ODLayoutScrolltop.init('od_scrolltop');

      // Init Sticky Card
      ODLayoutStickyCard.init('od_page_sticky_card');

      // Init Stretched Card
      ODLayoutStretchedCard.init('od_page_stretched_card');

      // Init Quick Offcanvas Panel
      ODLayoutQuickPanel.init('od_quick_panel');

      // Init Quick User Panel
      ODLayoutQuickUser.init('od_quick_user');

      // Init Quick User Panel
      SettingsPanel.init('od_settings_panel');

      // Init Aside Menu Toggle
      ODModulesDropdownToggle.init('od_modules_dropdown_toggle');
    });
  }, []);
  return <></>;
}
